export const getImageAspectRatio = (src: string): Promise<number> => {
  return new Promise(resolve => {
    const image = document.createElement('img');
    image.src = src;

    image.onload = () => resolve(image.naturalWidth / image.naturalHeight);
  });
};

export const getVideoAspectRatio = (src: string): Promise<number> => {
  return new Promise(resolve => {
    const video = document.createElement('video');
    video.src = src;

    video.onload = () => resolve(video.videoWidth / video.videoHeight);
  });
};
